<template>
  <div class="add-family container">
    <breadcrumbs
      v-if="isAdmin"
      :breadcrumb-links="[{url:adminHomeURL, text: 'Admin home'},{text: 'Add families'}]"
    />


    <!-- Upload Recipient Section -->
    <b-tabs class="tab-addnames">
      <create-family-tab />
      <upload-tab />
    </b-tabs>

    <!-- List Families Section -->
    <family-list />
  </div> <!-- closes container -->
</template>

<script>
import UploadTab from '../components/AddFamily/UploadTab';
import CreateFamilyTab from '../components/AddFamily/CreateFamilyTab';
import FamilyList from '../components/AddFamily/FamilyList';
import metadata from '../util/metadata';
import Breadcrumbs from '../components/Breadcrumbs';
import routeNames from '../util/routeNames';
import roles from '../util/roles';
import store from '../store/store';

export default {
  name: 'AddFamily',
  metaInfo: {
    title: `Add Families | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'The familylist page in starter app' }
    ]
  },
  components: { UploadTab, CreateFamilyTab, FamilyList, Breadcrumbs },
  data() {
    return {
      adminHomeURL: routeNames.ADMIN.PATH
    }
  },
  computed: {
    isAdmin() {
      return store.getters.getUserRole === roles.ADMIN;
    }
  }
}
</script>

<style lang="scss">
.add-family {
  .tab-addnames {
    margin-top: 30px;
  }
}
</style>
